// src/pages/License.jsx
import React from "react";
import { Scale } from "lucide-react";
import Footer from "../components/Footer";

const License = () => {
  return (
    <>
      <main className="page license-page min-h-[80vh] py-16 px-6 md:px-16 bg-white">
        <section className="max-w-5xl mx-auto">
          <div className="mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-semibold mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              License
            </div>
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2.5 rounded-full bg-emerald-100">
                <Scale className="w-5 h-5 text-emerald-700" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-slate-900">
                <span className="text-emerald-700">Ori</span>
                <span className="text-purple-500">genomi</span> License
              </h1>
            </div>
            <p className="text-sm md:text-base leading-relaxed text-slate-700 max-w-3xl">
              Origenomi is open source and free to use for everyone, including
              commercial use. The software is distributed under the MIT License.
            </p>
          </div>

          <div className="bg-slate-50 border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm">
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-slate-900">
              MIT License
            </h2>
            <div className="space-y-4 text-sm md:text-base leading-relaxed text-slate-700">
              <p>
                Copyright © {new Date().getFullYear()} Origenomi Team, Department of
                Biotechnology, IIT Hyderabad
              </p>
              <p>
                Permission is hereby granted, free of charge, to any person
                obtaining a copy of this software and associated documentation
                files (the "Software"), to deal in the Software without
                restriction, including without limitation the rights to use,
                copy, modify, merge, publish, distribute, sublicense, and/or
                sell copies of the Software, and to permit persons to whom the
                Software is furnished to do so, subject to the following
                conditions:
              </p>
              <p>
                The above copyright notice and this permission notice shall be
                included in all copies or substantial portions of the Software.
              </p>
              <p className="bg-white border border-slate-200 rounded-xl p-4 text-slate-600">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
                EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
                OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
                HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
                FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
                OTHER DEALINGS IN THE SOFTWARE.
              </p>
            </div>
          </div>

          <div className="mt-8 bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
            <h3 className="text-lg font-semibold text-slate-900 mb-3">
              What does this mean?
            </h3>
            <ul className="text-sm md:text-base leading-relaxed text-slate-700 list-disc pl-5 space-y-2">
              <li>You can use Origenomi freely for personal, academic, or commercial purposes</li>
              <li>You can modify the source code and create derivative works</li>
              <li>You can distribute copies of the original or modified software</li>
              <li>The only requirement is to include the original license and copyright notice</li>
            </ul>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default License;
